import React, { useState } from "react";
import PropTypes from "prop-types";
import { OrdersTable } from "@secondcloset/web-components";
import { get } from "lodash-es";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Input, Button, Popover } from "antd";
import { Link } from "react-router-dom";
import guide from "./images/guide.gif";

const SyncOrderView = (props) => {
  const [orderNumber, setOrderNumber] = useState("");

  const renderGuide = () => {
    const content = (
      <div className="guide">
        How to find Shopify Order ID?
        <img src={guide} alt="how to find shopify order number" />
      </div>
    );

    return (
      <Popover content={content}>
        How to find Shopify Order ID? <QuestionCircleOutlined className="shipment-tag-description-trigger" />
      </Popover>
    );
  };

  const renderSearchSection = () => {
    return (
      <div className="search-section">
        <div className="search-bar-wrap">
          <div className="input-row">
            <Input
              placeholder="Please Enter Shopify Order ID"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
            />
            <Button type="primary" disabled={!orderNumber.trim()} onClick={() => props.onSyncOrder(orderNumber.trim())}>
              Sync Order
            </Button>
          </div>
          <div className="description">{renderGuide()}</div>
        </div>
      </div>
    );
  };

  const renderTable = () => {
    const selectedOrderID = get(props.selectedOrder, "id");

    return (
      <div className="orders-table-wrap">
        <OrdersTable
          orders={props.foundOrder ? [props.foundOrder] : []}
          page={1}
          isLoading={props.loading}
          withAction
          onOrderSelect={(order) => props.onSelectOrder(order)}
          renderOrderLinkComponent={(displayText, orderID) => (
            <Link to={`/fulfillment/orders/${orderID}`}>{displayText}</Link>
          )}
          selectedOrderID={selectedOrderID}
          pageSize={5}
        />
      </div>
    );
  };

  return (
    <div className="sync-order-view">
      {renderSearchSection()}
      {renderTable()}
    </div>
  );
};

SyncOrderView.propTypes = {
  foundOrder: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  selectedOrder: PropTypes.object,
  onSelectOrder: PropTypes.func.isRequired,
  onSyncOrder: PropTypes.func.isRequired,
};

export default SyncOrderView;
